import React from "react"
import { usePagination } from "store/search-filter/search-filter.reducer"
import TablePagination from "components/Molecules/TablePagination"

const Pagination = () => {
  const [page, setPage] = usePagination("benchmarks")

  return <TablePagination page={page} onPageChange={page => setPage(page)} />
}

export default Pagination
